var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"subtitulo"},[_vm._v("Projetos por Núcleo Solicitante")]),_c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"chart",attrs:{"id":"chart-projetos-nucleo-solicitante"}})])])
}]

export { render, staticRenderFns }